import { useGetTextTypeBannersV2 } from '@/apis/rest/generated/hooks'
import { TextTypeBannerAreaEnum } from '@/apis/rest/generated/types'
import TextBannerSlider from '@/components/common/slider/TextBannerSlider'
import { usePetType } from '@/containers/hooks'
import { makeProductDetailTextBanners } from '@/utils/banner.util'
import { FitpetMallEventEnum } from '@/utils/event-tracker/events'

type ProductDetailInformationTextBannerProps = {
  id: number
  productName: string
}

export const ProductDetailInformationTextBanner = ({ id, productName }: ProductDetailInformationTextBannerProps) => {
  const { getPetType } = usePetType()
  const { data, isLoading, isError } = useGetTextTypeBannersV2(
    { petType: getPetType(), area: [TextTypeBannerAreaEnum.PDP] },
    { query: { select: (data) => makeProductDetailTextBanners(data, Number(id), productName) } }
  )

  const eventTrackerName = {
    view: FitpetMallEventEnum.ViewProductdetailTextbanner,
    click: FitpetMallEventEnum.ClickProductdetailTextbanner,
  }

  return <TextBannerSlider banners={data} eventTrackerName={eventTrackerName} isLoading={isLoading} isError={isError} />
}
